import './showingStatus.scss';


const ShowingStatus = ({ showing }) => {
    return (
        <div className={`showing-status-component ${showing.status}`}>{showing.status_display}</div>
    )
}

export default ShowingStatus;